// extracted by mini-css-extract-plugin
export default {"editTemplateModal":"EditTemplateModal_editTemplateModal__w08GU","content":"EditTemplateModal_content__60yha"};